module.exports = __webpack_public_path__ + "static/img/7.cd56b87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/17/7.png
// module id = BV35
// module chunks = 2